package one.healthium.domain.paywall.models

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import kotlinx.serialization.json.JsonNames
import one.healthium.base.utils.DeviceClass.Default
import one.healthium.base.utils.DeviceClass.Low
import one.healthium.base.utils.DeviceClass.Mid
import one.healthium.base.utils.DeviceClass.Plus
import one.healthium.base.utils.DeviceClass.Promax
import one.healthium.base.utils.DeviceClass.i13Pro
import one.healthium.base.utils.DeviceClass.i14Pro

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@SerialName("empty_space")
data class PaywallEmptyView(
    @JsonNames("id") override val id: String,
    @SerialName("config") val config: PaywallEmptyViewConfig? = null,
    @SerialName("config_plus") val configPlus: PaywallEmptyViewConfig? = null,
    @SerialName("config_mid") val configMid: PaywallEmptyViewConfig? = null,
    @SerialName("config_low") val configLow: PaywallEmptyViewConfig? = null,
    @SerialName("config_13pro") val config13pro: PaywallEmptyViewConfig? = null,
    @SerialName("config_14pro") val config14pro: PaywallEmptyViewConfig? = null,
    @SerialName("config_promax") val configPromax: PaywallEmptyViewConfig? = null
) : PaywallScreenView {
    @Transient
    val configs = mapOf(
        Default to config,
        Plus to configPlus,
        Mid to configMid,
        Low to configLow,
        i13Pro to config13pro,
        i14Pro to config14pro,
        Promax to configPromax,
    )
}

@Serializable
data class PaywallEmptyViewConfig(
    @SerialName("value") val value: Int,
)